/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';

/**
 * 
 * @export
 * @interface MilestoneResponse
 */
export interface MilestoneResponse {
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof MilestoneResponse
     */
    target: number;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof MilestoneResponse
     */
    rewardConfig: RewardConfigResponse;
    /**
     * 
     * @type {string}
     * @memberof MilestoneResponse
     */
    name: string;
}

/**
 * Check if a given object implements the MilestoneResponse interface.
 */
export function instanceOfMilestoneResponse(value: object): value is MilestoneResponse {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('rewardConfig' in value) || value['rewardConfig'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MilestoneResponseFromJSON(json: any): MilestoneResponse {
    return MilestoneResponseFromJSONTyped(json, false);
}

export function MilestoneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'rewardConfig': RewardConfigResponseFromJSON(json['rewardConfig']),
        'name': json['name'],
    };
}

export function MilestoneResponseToJSON(json: any): MilestoneResponse {
    return MilestoneResponseToJSONTyped(json, false);
}

export function MilestoneResponseToJSONTyped(value?: MilestoneResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
        'name': value['name'],
    };
}

